import { useMutationState } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";

export const useApprovingAdvisorIds = () =>
	useMutationState({
		filters: { mutationKey: AdvisorKeys.acceptConnection(), status: "pending" },
		select: (mutation) => mutation.state.variables,
	}).filter((advisorId): advisorId is number => typeof advisorId === "number");
